module.exports = __webpack_public_path__ + "assets/img/es.426a1551.svg";